import React from 'react';

import { formatCurrency } from '@brazilian-utils/brazilian-utils';
import {
  Flex, GridItem, HStack, Stack, Text,
} from '@chakra-ui/react';

import { Icon } from 'components';

function MoneyInfo({ label, value = 0 }: {label:string; value: number }) {
  if (Number.isNaN(value)) {
    return null;
  }
  return (
    <Stack>
      <Text
        color="gray.500"
        variant="xSmallSemiBold">{label}:
      </Text>
      <Text
        variant="largeBold"
        color="primary.default">
        {`R$ ${formatCurrency(Math.trunc(value * 100) / 100)}`}
      </Text>
    </Stack>
  );
}

export default function AverageCostCard({ data }) {
  return (
    <GridItem
      as={Flex}
      bg="white.default"
      color="gray.50"
      flexDir="column"
      borderRadius={8}
      colSpan={3}>
      <Flex
        p={2}
        px={4}
        borderBottom="1px">
        <Text
          color="gray.600"
          variant="xSmallBold">
          Custo Médio
        </Text>
      </Flex>
      <Flex
        p={4}>
        <HStack
          spacing={4}
          width="100%">
          <Flex
            align="center"
            justify="center"
            borderRadius={8}
            h={10}
            w={10}
            bg="primary.transparent">
            <Icon
              size="xl"
              color="primary.default"
              name="dollar-sign"
            />
          </Flex>
          <MoneyInfo
            label="Material"
            value={data?.valuePerMaterial}
          />
          <MoneyInfo
            label="Paciente"
            value={data?.valuePerPatient}
          />
          <MoneyInfo
            label="Custo logístico"
            value={data?.totalValue}
          />
        </HStack>
      </Flex>
    </GridItem>
  );
}
